var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 34,
    viewBox: "0 0 18 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7788 8.91282C18.0199 9.18067 18.0668 9.47532 17.9194 9.79675L7.07122 33.0401C6.89712 33.3749 6.61587 33.5423 6.22747 33.5423C6.1739 33.5423 6.08015 33.5289 5.94622 33.5021C5.71854 33.4351 5.54444 33.3079 5.4239 33.1204C5.31676 32.9329 5.28997 32.732 5.34354 32.5177L9.30113 16.2856L1.14488 18.3146C1.09131 18.328 1.01095 18.3347 0.903812 18.3347C0.66274 18.3347 0.455151 18.261 0.281044 18.1137C0.0399723 17.9128 -0.0470812 17.6517 0.0198831 17.3302L4.05783 0.756565C4.1114 0.569065 4.21854 0.415048 4.37926 0.294513C4.53997 0.173977 4.72747 0.113708 4.94176 0.113708H11.531C11.7855 0.113708 11.9998 0.200762 12.1739 0.37487C12.348 0.535583 12.4351 0.72978 12.4351 0.957458C12.4351 1.0646 12.4016 1.18514 12.3346 1.31907L8.89935 10.6204L16.8547 8.65166C16.9618 8.62487 17.0422 8.61148 17.0958 8.61148C17.3502 8.61148 17.5779 8.71192 17.7788 8.91282Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwap);
export default __webpack_public_path__ + "static/media/IconSwap.df8c5e2743cd08815081060b93400f50.svg";
export { ForwardRef as ReactComponent };